import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Login = lazy(() => import('../pages/login/page'));
const PersonalityTest = lazy(() => import('../pages/personality-test/page'));
const PersonalityResult = lazy(() => import('../pages/personality-result/page'));
const PersonalityPreview = lazy(() => import('../pages/personality-preview/page'));
const EmailVerification = lazy(() => import('../pages/email-verification/page'));
const BasicInfo = lazy(() => import('../pages/basic-info/page'));
const InviteFriends = lazy(() => import('../pages/invite-friends/page'));
const Matching = lazy(() => import('../pages/matching/page'));
const MatchingPreview = lazy(() => import('../pages/matching-preview/page'));
const LogoSelection = lazy(() => import('../pages/logo-selection/page'));
const ResetPassword = lazy(() => import('../pages/reset-password/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/personality-test',
    element: <PersonalityTest />,
  },
  {
    path: '/personality-result',
    element: <PersonalityResult />,
  },
  {
    path: '/personality-preview',
    element: <PersonalityPreview />,
  },
  {
    path: '/email-verification',
    element: <EmailVerification />,
  },
  {
    path: '/basic-info',
    element: <BasicInfo />,
  },
  {
    path: '/invite-friends',
    element: <InviteFriends />,
  },
  {
    path: '/matching',
    element: <Matching />,
  },
  {
    path: '/matching-preview',
    element: <MatchingPreview />,
  },
  {
    path: '/logo-selection',
    element: <LogoSelection />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
